module.exports = __webpack_public_path__ + "img/Screen_Shot_1.9e3e034f.png";